<template>
  <Container class="tw-flex tw-h-dvh tw-items-center tw-justify-center">
    <div class="tw-max-w-md">
      <Logo class="tw-mx-auto tw-mb-8 tw-max-w-60" />
      <h1 class="tw-mb-4 tw-text-center tw-text-2xl">Welcome</h1>
      <div class="tw-mb-8">
        <template v-if="isShowingForm">
          <p class="tw-mb-8 tw-text-center">
            Do you already have an account?
            <a :href="loginUri"> Login here </a>
          </p>

          <SignupForm />
        </template>
        <template v-else>
          <GpBtnLink
            class="tw-block tw-w-full"
            :href="loginUri"
            v-playwright="'unauthorized-login-link'"
            >Login</GpBtnLink
          >
          <p class="tw-my-4 tw-text-center">New to GPCORE?</p>
          <GpBtn
            class="tw-block tw-w-full"
            v-playwright="`register-toggle-form`"
            @click="toggleRegisterForm"
          >
            Create an account
          </GpBtn>
        </template>
      </div>
      <p class="tw-text-center tw-text-sm tw-text-gp-rhino">
        This site is protected by reCAPTCHA, so the Google
        <ExternalLink url="https://policies.google.com/privacy">privacy policy</ExternalLink>
        and
        <ExternalLink url="https://policies.google.com/terms">terms of service</ExternalLink>
        apply.
      </p>
    </div>
  </Container>
</template>

<script lang="ts">
import { GpBtn, GpBtnLink, PasswordStrength } from '@gportal/uikit';
import SignupForm from '@panel/components/unauthorized/SignupForm.vue';
import useViewTitle from '@panel/composables/useViewTitle';
import { useSessionStore } from 'gpcore-apikit/store/pinia/session';
import Container from 'gpcore-uikit/components/Component.Container.vue';
import Logo from 'gpcore-uikit/icons/logo.vue';
import ExternalLink from 'gpcore-uikit/components/Component.ExternalLink.vue';
import { defineComponent, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'Register',
  components: {
    GpBtn,
    GpBtnLink,
    Container,
    SignupForm,
    ExternalLink,
    Logo,
  },
  setup() {
    useViewTitle('Welcome');

    const router = useRouter();
    const sessionStore = useSessionStore();
    const loginUri = ref<string>('');
    const getLoginUri = async () => {
      const route = router.resolve({ name: 'Home' });

      loginUri.value = await sessionStore.keycloak.createLoginUrl({
        redirectUri: new URL(route.href, window.location.origin).href,
      });
    };

    const isShowingForm = ref<boolean>(false);
    const toggleRegisterForm = () => {
      isShowingForm.value = true;
    };

    onMounted(() => {
      getLoginUri();
    });

    return {
      loginUri,
      isShowingForm,
      toggleRegisterForm,

      PasswordStrength,
    };
  },
});
</script>
